<template>
  <div class="commoditysearchstyle">
    <!-- 标题 -->

    <!-- <p style="color: #323233; font-size: 14px">搜索热词</p>
    <p style="font-size: 12px; color: #969799; margin-top: 10px">
      鼠标拖拽调整热词顺序，搜索框默认展示第一个热词，其他搜索词将以标签形式显示在搜索页中
    </p> -->

    <!-- 表单 -->
    <el-form
      label-width="80px"
      :model="datas"
      size="small"
      style="margin-top: 20px"
      class="lef"
    >
      <!-- <div v-if="datas.hotords[0]">
        <vuedraggable v-model="datas.hotords" v-bind="dragOptions">
          <transition-group>
            <section
              class="imgList"
              v-for="(item, index) in datas.hotords"
              :key="item + index"
            >
              <i class="el-icon-circle-close" @click="deleteHotords(index)" />
              <div class="imgText">
                <el-input v-model="item.text" placeholder="请输入热词" />
              </div>
            </section>
          </transition-group>
        </vuedraggable>
      </div> -->

      <!-- 添加热词 -->
      <!-- <el-button @click="addHotords" class="uploadImg" type="primary" plain
        ><i class="el-icon-plus" />点击添加热词</el-button
      > -->
      <el-form-item label="模块名称：" v-if="!datas.isShowModuleName">
        <div class="weiz">
          <div class="ml35">
            <el-input disabled v-model="datas.moduleName"> </el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="文本标题：">
        <div class="weiz">
          <div class="ml35">
            <el-input placeholder="请输入文本标题" v-model="datas.text">
            </el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        label="字体："
        prop="fontWeight"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.fontFamily" placeholder="请选择字体">
              <el-option
                v-for="item in fontFamilyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 标题大小 -->
      <el-form-item
        label="字号："
        prop="wordSize"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.fontSize" placeholder="请选择字号">
              <el-option
                v-for="item in wordSizeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 文字颜色 -->
      <el-form-item class="lef" label="颜色：">
        <div class="weiz">
          <div style="margin-left: 35px">
            <el-color-picker
              v-model="datas.textColor"
              show-alpha
              @change="handleCustomColorChange($event, 'textColor')"
            ></el-color-picker>
          </div>
          <div>
            <el-input placeholder="请输入文字颜色" v-model="datas.textColor">
            </el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="lef" label="背景：">
        <div class="weiz">
          <div class="ml35">
            <!--背景颜色子组件 -->
            <LinkInput :datas="datas" field="backgroundColor" defaultColor="defaultBackgroundColor" type="color" />
          </div>
        </div>
      </el-form-item>
       <el-form-item class="lef" label="边框：">
        <div class="weiz">
          <div class="ml35">
            <el-color-picker
              v-model="datas.borderColor"
              show-alpha
            ></el-color-picker>
          </div>
          <div>
            <el-input placeholder="请输入边框颜色" v-model="datas.borderColor">
            </el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        label="搜索内容："
        prop="wordSize"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select
              v-model="datas.serachCotent"
              placeholder="请选择搜索内容"
            >
              <el-option
                v-for="item in searchOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 卡片样式选择 -->
      <el-form-item class="lef" label="模块样式：">
        <div class="weiz">
          <div class="weiz-container" style="">
            <!-- 模块样式 -->
            <div
              v-for="(item, index) in moduleStyleList"
              :key="index"
              @click="clickChange(item, index)"
              class="preview-item"
              :class="{ active: moduleStyleType == item.moduleStyleType }"
            >
              <RightPanelModuleStyle
                :datas="item"
                :imagePath="item.src"
              ></RightPanelModuleStyle>
            </div>
          </div>
        </div>
      </el-form-item>
      <!-- 扫一扫 -->
      <!-- <el-form-item class="lef" label="扫一扫">
        {{ datas.sweep ? "显示" : "隐藏" }}
        <el-checkbox style="margin-left: 196px" v-model="datas.sweep" />
      </el-form-item> -->
      <!-- 框体高度 -->
    </el-form>
  </div>
</template>

<script>
import vuedraggable from "vuedraggable"; //拖拽组件
import {
  wordSizeOptions,
  fontFamilyOptions,
  predefineColors,
  searchOptions,
} from "@/utils/defaultData.js";

export default {
  name: "commoditysearchstyle",
  props: {
    datas: Object,
  },
  components: { vuedraggable },
  data() {
    return {
      moduleStyleType: 1, //默认选中的模块样式
      // 构造模块样式列表
      moduleStyleList: [
        { ...this.datas, src: this.$imagePath.image22, moduleStyleType: 1 },
        {
          ...this.datas,
          src: this.$imagePath.image23,
          moduleStyleType: 2,
        },
      ],
      // ✅ 新增：字体类型下拉列表【核心】
      fontFamilyOptions: fontFamilyOptions,
      // 字号下拉列表
      wordSizeOptions: wordSizeOptions,
      // 搜索内容
      searchOptions: searchOptions,
      // 选项列表1
      textOptions: [
        {
          value: 12,
          label: "12",
        },
        {
          value: 13,
          label: "13",
        },
        {
          value: 14,
          label: "14",
        },
      ],
      borderRadiusList: [10, 30], // 预览组件的配置列表
      previewOptions: [], // 预览组件的配置列表
      predefineColors: predefineColors,
      dragOptions: {
        //拖拽配置
        animation: 200,
      },
    };
  },
  created() {
    // 初始化预览配置
    this.updatePreviewOptions();
  },
  watch: {
    // 深度监听datas变化，实时更新预览配置
    datas: {
      handler() {
        this.updatePreviewOptions();
      },
      deep: true,
      immediate: true, // 初始化时立即执行
    },
  },

  methods: {
    //模块样式选择回调
    clickChange(item, index) {
      console.log(
        "搜索组件模块样式点击了",
        item,
        index,
        this.datas,
        this.moduleStyleType,
      );
      this.moduleStyleType = item.moduleStyleType;
      this.datas.moduleStyleType = item.moduleStyleType;
    },
    // ✅ 核心方法：点击选中某个圆角样式，同步更新到datas.borderRadius
    selectBorderRadius(radius) {
      this.datas.borderRadius = radius;
      console.log("点击选中了", this.datas, radius);
    },
    // 生成预览组件的配置列表
    updatePreviewOptions() {
      this.previewOptions = this.borderRadiusList.map((radius) => {
        // 深拷贝datas，避免修改原数据
        return {
          ...JSON.parse(JSON.stringify(this.datas)),
          borderRadius: radius,
        };
      });
    },
    // 处理文字颜色选择器变化
    handleCustomColorChange(color, type) {
      console.log("文字颜色选择事件", color, type);
      this.datas[type] = color;
    },
    /* 添加热词 */
    addHotords() {
      this.datas.hotords.push({
        text: "",
      });
    },
    /* 删除热词 */
    deleteHotords(index) {
      this.datas.hotords.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
// 覆盖element原有样式
::v-deep.el-form {
  .el-card {
    .el-card__body {
      padding: 10px 0;
      .el-form-item {
        .el-form-item__label {
          color: #9c9b9b !important;
          font-size: 13px !important;
        }
        .el-form-item__content {
          margin-left: 20px !important;
          margin-right: 20px !important;
        }
      }
    }
  }
}
.commoditysearchstyle {
  width: 100%;
  left: 0;
  top: 0;
  padding: 0 10px 20px;
  box-sizing: border-box;
  /* 标题 */
  h2 {
    padding: 24px 16px 24px 0;
    margin-bottom: 15px;
    border-bottom: 1px solid #f2f4f6;
    font-size: 18px;
    font-weight: 600;
    color: #323233;
  }

  /* 上传图片按钮 */
  .uploadImg {
    width: 345px;
    height: 40px;
    margin-top: 10px;
  }

  /* 热词列表 */
  .imgList {
    padding: 6px 12px;
    margin: 16px 7px;
    border-radius: 2px;
    background-color: #fff;
    box-shadow: 0 0 4px 0 rgba(10, 42, 97, 0.2);
    display: flex;
    position: relative;

    /* 删除图标 */
    .el-icon-circle-close {
      position: absolute;
      right: -10px;
      top: -10px;
      cursor: pointer;
      font-size: 19px;
    }

    /* 热词文字 */
    .imgText {
      width: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      justify-content: space-between;
    }
  }

  /* 图片样式 */
  .weiz {
    display: flex;
    .weiz-content {
      margin-left: 35px;
      width: 100%;
    }
    .weiz-container {
      margin-left: 10px;
      width: 100%;
    }
    // ✅ 预览项 悬浮+选中+基础样式 核心CSS
    .preview-item {
      margin-top: 10px;
      cursor: pointer;
      padding: 3px;
      border-radius: 6px;
      transition: all 0.2s ease;
      border: 1px solid #ebedf0;
      &:hover {
        border-color: #155bd4;
        background: #f5f8ff;
      }
      // ✅ 选中后的激活样式，和你项目里其他激活样式一致的蓝色主题
      &.active {
        border: 1px solid #155bd4;
        background: #e0edff;
      }
      .preview-label {
        font-size: 12px;
        color: #666;
        margin-bottom: 8px;
        text-align: center;
      }
    }
    // justify-content: space-between;
    i {
      padding: 5px 14px;
      margin-left: 10px;
      border-radius: 0;
      border: 1px solid #ebedf0;
      font-size: 20px;
      font-weight: 500;
      cursor: pointer;

      &:last-child {
        font-size: 22px;
      }

      &.active {
        color: #155bd4;
        border: 1px solid #155bd4;
        background: #e0edff;
      }
    }
  }

  .lef {
    ::v-deep.el-form-item__label {
      text-align: right;
    }
  }

  /* 颜色选择器 */
  .picke {
    float: right;
  }
}
</style>
